import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'

const pdf1 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/2021RegionalWaterPlan/2021_RegionH_RWP_Volume1.pdf';
const pdf2 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/2021RegionalWaterPlan/2021_RegionH_RWP_Volume2.pdf';
const pdf3 = 'https://fnicdn.blob.core.windows.net/regionh/documents/Reg_H_2016_RWP_20151116.pdf';
const pdf4 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/00a_Front_Matter_000.pdf';
const pdf5 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/00b_Executive_Summary_000.pdf';
const pdf6 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/01_Chapter_1_000.pdf';
const pdf7 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/02_Chapter_2_000.pdf';
const pdf8 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/03_Chapter_3_000.pdf';
const pdf9 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/04_Chapter_4_001.pdf';
const pdf10 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/05_Chapter_5_001.pdf';
const pdf11 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/06_Chapter_6_000.pdf';
const pdf12 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/07_Chapter_7_000.pdf';
const pdf13 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/08_Chapter_8_000.pdf';
const pdf14 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/09_Chapter_9_000.pdf';
const pdf15 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/10_Chapter_10_000.pdf';
const pdf16 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/H_ExecutiveSummary.pdf';
const pdf17 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task1Report.pdf';
const pdf18 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task2Report.pdf';
const pdf19 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task3Report.pdf';
const pdf20 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task4Report.pdf';
const pdf21 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task5Report.pdf';
const pdf22 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task6Report.pdf';
const pdf23 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/Task7Report.pdf';
const pdf24 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/RegionH_2026_RWP_Vol1.pdf';
const pdf25 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/RegionH_2026_RWP_Vol2_Part1.pdf';
const pdf26 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/RegionH_2026_RWP_Vol2_Part2.pdf';
const pdf27 = 'https://fnicdn.blob.core.windows.net/regionh/downloads/documents/RegionH_2026_RWP_Vol2_Part3.pdf';


export default function PlanningDocs() {
  return (
    <div>

      <main role="main" className="flex-shrink-0 min-vh-100">
        <div className='container'>
          <div className='row ps-4 mb-3'>
            <h3>Planning Documents</h3>
          </div>
          <div className='row ps-lg-4'>
            <h4>2026 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li><a href={pdf24} rel="noreferrer" target="_blank">2026 Regional Water Plan Volume 1</a></li>
              <li><a href={pdf25} rel="noreferrer" target="_blank">2026 Regional Water Plan Volume 2 Pt I</a></li>
              <li><a href={pdf26} rel="noreferrer" target="_blank">2026 Regional Water Plan Volume 2 Pt II</a></li>
              <li><a href={pdf27} rel="noreferrer" target="_blank">2026 Regional Water Plan Volume 2 Pt III</a></li>
            </ul>
          </div>
          <div className='row ps-lg-4'>
            <h4>2021 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li><a href={pdf1} rel="noreferrer" target="_blank">2021 Regional Water Plan Volume 1</a></li>
              <li><a href={pdf2} rel="noreferrer" target="_blank">2021 Regional Water Plan Volume 2</a></li>
            </ul>
          </div>
          <div className='row ps-lg-4'>
            <h4>2016 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li><a href={pdf3} rel="noreferrer" target="_blank">2016 Regional Water Plan</a></li>
            </ul>
          </div>
          <div className='row ps-lg-4'>
            <h4>2011 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li> <a href={pdf4} rel="noreferrer" target="_blank">TOC and Abbreviations and Conversions</a> </li>
              <li> <a href={pdf5} rel="noreferrer" target="_blank">Executive Summary</a> </li>
              <li> <a href={pdf6} rel="noreferrer" target="_blank">Chapter 1 - Description of Region</a> </li>
              <li> <a href={pdf7} rel="noreferrer" target="_blank">Chapter 2 - Presentation of Population and Water Demands</a> </li>
              <li> <a href={pdf8} rel="noreferrer" target="_blank">Chapter 3 - Analysis of Current Water Supplies</a> </li>
              <li> <a href={pdf9} rel="noreferrer" target="_blank">Chapter 4 - Presentation of Water Management Strategies Based on Needs</a> </li>
              <li> <a href={pdf10} rel="noreferrer" target="_blank">Chapter 5 - Impacts of Management Strategies on Water Quality and Impacts of</a> <a href="documents/2011RWP_Chapter5.pdf">Moving Water from Rural and Agricultural Areas</a> </li>
              <li> <a href={pdf11} rel="noreferrer" target="_blank">Chapter 6 - Water Conservation and Drought Management Plans</a> </li>
              <li> <a href={pdf12} rel="noreferrer" target="_blank">Chapter 7 - Long Term Protection of the State's Water Resources, Agricultural Resources and Natural Resources</a> </li>
              <li> <a href={pdf13} rel="noreferrer" target="_blank">Chapter 8 - Ecologically Unique Stream Segments, Unique Reservoir Sites and Legislative Recommendations</a> </li>
              <li> <a href={pdf14} rel="noreferrer" target="_blank">Chapter 9 - Water Infrastructure Financing</a> </li>
              <li> <a href={pdf15} rel="noreferrer" target="_blank">Chapter 10 - Public Participation in Developing the 2011 Region H Water Plan</a> </li>
            </ul>
          </div>
          <div className='row ps-lg-4'>
            <h4>2006 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li><a href="https://www.twdb.texas.gov/waterplanning/rwp/plans/2006/H/Region_H_2006_RWP1-4.pdf" rel="noreferrer" target="_blank">Chapters 1 - 4</a></li>
              <li><a href="https://www.twdb.texas.gov/waterplanning/rwp/plans/2006/H/Region_H_2006_RWP5-10.pdf" rel="noreferrer" target="_blank">Chapters 5 - 10</a></li>
            </ul>
          </div>
          <div className='row ps-lg-4 mb-5'>
            <h4>2001 Regional Water Plan</h4>
            <ul className='ps-5'>
              <li><a href={pdf16} rel="noreferrer" target="_blank">Executive Summary </a></li>
              <li><a href={pdf17} rel="noreferrer" target="_blank">Chapter 1 – Description of Region </a></li>
              <li><a href={pdf18} rel="noreferrer" target="_blank">Chapter 2 – Presentation of Population and Water Demands </a></li>
              <li><a href={pdf19} rel="noreferrer" target="_blank">Chapter 3 – Analysis of Current Water Supplies</a></li>
              <li><a href={pdf20} rel="noreferrer" target="_blank">Chapter 4 – Impacts of Water Shortages</a></li>
              <li><a href={pdf21} rel="noreferrer" target="_blank">Chapter 5 – Identification, Evaluation and Selection of Water Management  Strategies</a></li>
              <li><a href={pdf22} rel="noreferrer" target="_blank">Chapter 6 – Additional Recommendations </a></li>
              <li><a href={pdf23} rel="noreferrer" target="_blank">Chapter 7 - Public Involvement in Developing the Region H Water Plan</a>  </li>
            </ul>
          </div>
        </div>
      </main>

    </div>
  )
}
